<div class="container">
  <div class="section">
  <div *ngFor="let content of contents" [innerHTML]="content"></div>
  </div>
</div>